import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const COLORS = { black: '#0A0A0A', white: '#F5F5F0', gold: '#C9A84C', gray: '#888' };
const DASHBOARD_URL = import.meta.env.VITE_DASHBOARD_URL || 'https://app.qrqy.shop';

// TODO(M2): Replace hamburger placeholder with real mobile nav drawer

export default function Nav({ cartCount = 0 }) {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  function isActive(path) {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  }

  const linkStyle = (path) => ({
    textDecoration: 'none',
    fontSize: '0.75rem',
    letterSpacing: '0.15em',
    fontWeight: 600,
    color: isActive(path) ? COLORS.gold : COLORS.white,
    opacity: isActive(path) ? 1 : 0.7,
    transition: 'opacity 0.15s, color 0.15s',
    paddingBottom: '2px',
    borderBottom: isActive(path) ? `1px solid ${COLORS.gold}` : '1px solid transparent',
  });

  const externalLinkStyle = {
    textDecoration: 'none',
    fontSize: '0.75rem',
    letterSpacing: '0.15em',
    fontWeight: 600,
    color: COLORS.white,
    opacity: 0.7,
    transition: 'opacity 0.15s',
  };

  return (
    <header style={{
      position: 'sticky',
      top: 0,
      zIndex: 100,
      backgroundColor: COLORS.black,
      borderBottom: `1px solid rgba(255,255,255,0.07)`,
    }}>
      <nav style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 2rem',
        height: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        {/* Wordmark */}
        <Link to="/" style={{ textDecoration: 'none' }}>
          <span style={{
            fontSize: '1.5rem',
            fontWeight: 900,
            letterSpacing: '0.15em',
            color: COLORS.white,
            fontFamily: 'Inter, system-ui, sans-serif',
          }}>
            QRQY
          </span>
        </Link>

        {/* Desktop nav links */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '2.5rem' }}>
          <Link to="/shop" style={linkStyle('/shop')}>SHOP</Link>
          <Link to="/how-it-works" style={linkStyle('/how-it-works')}>HOW IT WORKS</Link>
          <a
            href={DASHBOARD_URL}
            style={externalLinkStyle}
            target="_blank"
            rel="noopener noreferrer"
          >
            MY QRS
          </a>
        </div>

        {/* Cart icon with count badge */}
        <Link to="/cart" style={{ textDecoration: 'none', position: 'relative' }}>
          <span style={{
            fontSize: '0.75rem',
            letterSpacing: '0.15em',
            fontWeight: 600,
            color: COLORS.white,
            opacity: 0.85,
          }}>
            CART
          </span>
          {cartCount > 0 && (
            <span style={{
              position: 'absolute',
              top: '-8px',
              right: '-12px',
              backgroundColor: COLORS.gold,
              color: COLORS.black,
              borderRadius: '50%',
              width: '18px',
              height: '18px',
              fontSize: '0.65rem',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              {cartCount > 9 ? '9+' : cartCount}
            </span>
          )}
        </Link>

        {/* TODO(M2): Mobile hamburger — render below 768px breakpoint */}
      </nav>

      {/* TODO(M2): Mobile nav drawer component */}
    </header>
  );
}
